import {
  convertToGAIndex,
  sendGAEvent,
  sendGALinkClickEvent,
} from '@noths/polaris-client-google-analytics';

import type { DrilldownNavItem } from 'client-site-chrome-ui/types/drilldownNavItem';

const EVENT_CATEGORY = 'Navigation - mobile menu';

interface DrilldownPathItem extends Pick<DrilldownNavItem, 'level' | 'title'> {
  index: number;
}

const itemToPathItem = (item: DrilldownNavItem, index = 0) => ({
  title: item.title,
  level: item.level,
  index,
});

export const findPathToItem = (navigationData: DrilldownNavItem, targetItem: DrilldownNavItem) => {
  const loop = (
    path: DrilldownPathItem[],
    item: DrilldownNavItem,
    index?: number,
  ): DrilldownPathItem[][] => {
    return targetItem === item
      ? [[...path, itemToPathItem(targetItem, index)]]
      : item.items.reduce(
          (acc: DrilldownPathItem[][], child, thisIndex) =>
            acc.concat(loop([...path, itemToPathItem(item, index)], child, thisIndex)),
          [],
        );
  };

  return loop([], navigationData)[0].slice(1);
};

const buildEventLabelSegment = (pathItem: DrilldownPathItem) =>
  [pathItem.level, convertToGAIndex(pathItem.index), pathItem.title].join('|');

const buildEventLabel = (navigationData: DrilldownNavItem, targetItem: DrilldownNavItem) =>
  findPathToItem(navigationData, targetItem).map(buildEventLabelSegment).join('|');

export const selectItem = (navigationData: DrilldownNavItem, item: DrilldownNavItem) => {
  sendGAEvent({
    event: 'custom_event',
    event_category: EVENT_CATEGORY,
    event_action: 'Select',
    event_label: buildEventLabel(navigationData, item),
  });
};

export const clickLink = (
  evt: React.MouseEvent<HTMLAnchorElement>,
  navigationData: DrilldownNavItem,
  item: DrilldownNavItem,
) => {
  sendGALinkClickEvent(evt, {
    event: 'custom_event',
    event_category: EVENT_CATEGORY,
    event_action: 'Click',
    event_label: buildEventLabel(navigationData, item),
    destination_URL: item.url,
  });
};

export const back = (level: number) => {
  sendGAEvent({
    event: 'custom_event',
    event_category: EVENT_CATEGORY,
    event_action: 'Back',
    event_label: `Back to level ${convertToGAIndex(level)}`,
  });
};
